import React from "react";
import SearchForm from "./SearchForm";
import FeatureBadges from "./FeatureBadges";

const HeroContent = () => (
  <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8 w-full pt-12 pb-20 animate-fade-in">
    <div className="text-center mb-12 space-y-6">
      <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white text-balance">
        Find Your Commercial Property
      </h1>
      <p className="text-xl text-white/90 max-w-3xl mx-auto">
        Explore, research, and compare commercial properties in Sri Lanka.
      </p>
    </div>

    {/* Search Box */}
    <SearchForm />

    {/* Feature badges */}
    <FeatureBadges />
  </div>
);

export default HeroContent;
